import serviceProject from "../serviceProject";
import { getRoles } from "../../../service";

const Group = {
  ...serviceProject,
  getRoles,
  resource: "groups",
  resourceRole: "group"
};
export default Group;
